/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 1/3/20
 * Time: 1:58 PM
 */
import React, {Component} from 'react';
import './ViewSMS.scss';
import {Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import LabelDropdown from "../../../../components/Dropdown/Dropdown/DrpDwn";
import {Button} from "semantic-ui-react";
import moment from "moment";
import Download from "../../../../components/Button/DownloadbleButton";
import {MDBDataTable} from "mdbreact";
import {DatePicker, Empty, Icon, Spin} from "antd";
import * as TableHeader from "../../../../store/Reducer/DropDownConst";
import {connect} from "react-redux";
import Cookies from "js-cookie";
import axiosTags from "../../../../axios/axios_tag";
import * as common from "../../../../const/Common/CommonFunc";
import PieChart from '../../../../const/ChartFrame_SMS_Pie';
import apiConfig from "../../../../axios/axios_api_services";

const {RangePicker} = DatePicker;

function disabledDate(current) {
  return current && current > moment().endOf("day");
}

class App extends Component {
  state = {
    selected_category: -1,
    category_list: [],
    category_name: "",
    tags: 0,
    corporate_id: 0,
    spin: true,
    tags_list: [],
    data: [
      // {
      //   msisdn:"004116",
      //   smsBody:"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Adipisci animi aspernatur",
      //   dispatchDateTime:"2020-01-05 11:45",
      //   dispatchStatus:"INACTIVE",
      //   typeOfSms:"Checkin SMS",
      //   corporate:"Dialog Axita (PLC)",
      //   tagService:"VisitorTags",
      // },
    ],
    details: [],
    start_date: '',
    end_date: '',
    searchable_startDate: '',
    searchable_endDate: '',
    searchable_tags: '',
    searchable_corporate_id: '',
    sms_count: 0
  };

  titleOnChange = name => (e, {value}) => {
    if (name === 'corporate_id') {
      let tagServices = [];
      this.state.details.map((details, index) => {
        if (details.corporateId === value) {
          tagServices = details.services
        }
      });
      this.setState({
        [name]: value,
        tags_list: tagServices,
        tags: 0
      });
    } else {
      this.setState({
        [name]: value
      });
    }

  };

  onChange = (date, dateString) => {
    if (dateString[0] === "" || dateString[1] === "") {
    } else {
      let start = new Date(dateString[0]).getTime();
      let end = new Date(dateString[1]).getTime();
      this.setState({
        start_date: start,
        end_date: end,
      })
    }
  };
  filterHandler = () => {
    const {tags, corporate_id, start_date, end_date} = this.state;

    let condition = false;
    corporate_id === '' ? common.notifyMessage("Please select corporate") :
      tags === '' ? common.notifyMessage("Please select tag service") :
        condition = true;

    if (condition) {
      this.setState({
        spin: true
      });

      let startDate = new Date().setDate(new Date().getDate());
      let endDate = new Date().setDate(new Date().getDate());

      if (start_date !== "" && end_date !== "") {
        startDate = start_date;
        endDate = end_date;
      }

      const headers = {
        "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
      };

      // let url =
      //   "startDate=" + startDate +
      //   "&endDate=" + endDate +
      //   "&serviceId=" + tags +
      //   "&corporateId=" + corporate_id;

      axiosTags.get(apiConfig.SMS_REPORT({corporateId:corporate_id,serviceId:tags,startDate:startDate,endDate:endDate}), {headers: headers})
        .then(response => {
          if (response.data.success) {
            this.setState({
              searchable_startDate: startDate,
              searchable_endDate: endDate,
              searchable_tags: tags,
              searchable_corporate_id: corporate_id,
              data: [],
              selected_category: -1,
              category_list: response.data.body
            });
          } else {
            common.notifyMessage(response.data.message);
            this.setState({
              data: [],
              selected_category: -1,
              category_list: []
            })
          }
        })
        .catch(async error => {
          let result = await common.checkErrorResponse(error);
          if (result === 1) {
            this.filterHandler();
          }
        })
        .finally(fin => {
          this.setState({
            spin: false
          })
        });
    }
  };

  categoryfilterHandler = (category, index) => {

    const {
      searchable_startDate,
      searchable_endDate,
      searchable_tags,
      searchable_corporate_id,
    } = this.state;

    this.setState({
      spin: true
    });

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    axiosTags.get(apiConfig.SMS_REPORT_CATEGORY_FILTER({corporateId:searchable_corporate_id,categoryId:category.category,serviceId:searchable_tags,startDate:searchable_startDate,endDate:searchable_endDate}), {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({
            selected_category: index,
            category_name: category.category,
            data: response.data.body
          });
          // window.scrollTo(0, document.body.scrollHeight); // scroll to bottom
          document.querySelector(".hidden-field").scrollIntoView();
        } else {
          common.notifyMessage(response.data.message);
          this.setState({
            selected_category: index,
            data: []
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.categoryfilterHandler(category, index);
        }
      })
      .finally(fin => {
        this.setState({
          spin: false
        })
      });
  };

  getAllDetails = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axiosTags.get(apiConfig.SERVICES, {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({
            details: response.data.body,
          });
          this.filterHandler();
        } else {
          this.setState({
            details: [],
            spin: false
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllDetails();
        }
      });
  };

  componentDidMount() {
    this.getAllDetails();
  }

  render() {
    let corporate_options = [{value: 0, text: "All", key: 1}];
    let service_options = [{value: 0, text: "All", key: 1}];

    if (this.state.details.length !== 0) {
      this.state.details.map((details, index) => {
        const obj = {
          key: details.corporateId,
          text: details.corporateName,
          value: details.corporateId
        };
        corporate_options.push(obj)
      })
    }

    if (this.state.tags_list.length !== 0) {
      this.state.tags_list.map((details, index) => {
        const obj = {
          key: details.serviceId,
          text: details.serviceName,
          value: details.serviceId
        };
        service_options.push(obj)
      })
    }

    let rows = [];
    if (this.state.data.length !== 0) {
      this.state.data.map((data, index) => {
        const obj = {
          _1: data.msisdn,
          _2: data.smsBody,
          _3: data.dispatchDateTime,
          _4: data.dispatchStatus,
          _5: data.typeOfSms,
          _6: data.corporate,
          _7: data.tagService
        };
        rows.push(obj);
      })
    }
    // required-lbl
    let data = {columns: TableHeader.smsReports, rows: rows};

    let categorySuccessCount = 0;
    let categoryfailedCount = 0;
    if (this.state.category_list.length !== 0) {
      this.state.category_list.map((category, index) => {
        categorySuccessCount = categorySuccessCount + category.successCount;
        categoryfailedCount = categoryfailedCount + category.failedCount;
      })
    }

    // let PieChart = PieChart;
    let pieChart = PieChart;
    pieChart.series[0].data = [
      {
        name: "Success Count",
        y: categorySuccessCount,
        color: '#86d686',
        sliced: true,
        selected: true
      },
      {
        name: "Failed Count",
        y: categoryfailedCount,
        color: '#e8bfb7'
      }
    ];

    return (
      <div className={"corp-view-sms"}>
        <Spin spinning={this.state.spin} delay={10}
              indicator={<Icon type="loading" style={{fontSize: 24}} spin/>}>
          <div>
            <Row>
              <Col>
                <LabelDropdown
                  disabled={this.state.spin}
                  tagText={"Select Corporate"}
                  placeholder={"Select Corporate"}
                  options={corporate_options}
                  value={this.state.corporate_id}
                  onChange={this.titleOnChange("corporate_id")}
                />
              </Col>

              <Col xs={3}>
                <LabelDropdown
                  disabled={this.state.spin}
                  tagText={"Select Tag"}
                  placeholder={"Select Tag"}
                  options={service_options}
                  value={this.state.tags}
                  onChange={this.titleOnChange("tags")}
                />
              </Col>

              <Col>
                <label className={"required-lbll"}>Choose date ranges</label>
                <br/>
                <RangePicker
                  className={"rangepicker-super-meeting-report_"}
                  size={"mini"}
                  defaultValue={[moment().subtract(0, "days"), moment().subtract(0, "days")]}
                  disabledDate={disabledDate}
                  format="YYYY-MM-DD"
                  onChange={this.onChange}
                  allowClear={false}
                />

              </Col>
              <Col xs={3}>
                <Button.Group className={"dual-btn-rangepicker-corp-sms-report"}>
                  <Button positive onClick={this.filterHandler}>Search SMS</Button>
                </Button.Group>
              </Col>
            </Row>

          </div>
          <Row>
            {
              this.state.category_list.length !== 0 ?
                <Col md={4}
                     className={"un_selected_category"}>
                  <div className={"sms-count-wrapper"}>
                    <p className={"sms-count-txt"}>All SMS Count</p>

                    {/*<Row>*/}
                    {/*<Col>*/}
                    {/*<ReactHighChartBasicArea config={pieChart}/>*/}
                    {/*</Col>*/}
                    {/*</Row>*/}
                    <Row>
                      <Col className={"success-wrapper"} xs={7}>
                        <span className={"sms-count-green-txt"}>Success </span>
                        <p
                          className={"sms-count-value"}>{categorySuccessCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                      </Col>
                      <Col className={"failed-wrapper"} xs={5}>
                        <span className={"sms-count-failed-red-txt"}>Failed</span>
                        <p
                          className={"sms-count-failed-value"}>{categoryfailedCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                      </Col>
                    </Row>
                    <br/>

                    <p
                      className={"sms-count-description"}>{"The total number of SMS sent from the Application in the selected time period"}</p>
                  </div>
                </Col> : null
            }

            {
              this.state.category_list.length !== 0 ?
                this.state.category_list.map((category, index) => {
                  return <Col md={4} key={index}
                              className={this.state.selected_category === index ? "selected_category" : "un_selected_category"}>
                    <div className={"sms-count-wrapper"}>
                      <p className={"sms-count-txt"}>{category.category}</p>

                      <Row>
                        <Col className={"success-wrapper"} xs={7}>
                          <span className={"sms-count-green-txt"}>Success </span>
                          <p
                            className={"sms-count-value"}>{category.successCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                        </Col>
                        <Col className={"failed-wrapper"} xs={5}>
                          <span className={"sms-count-failed-red-txt"}>Failed</span>
                          <p
                            className={"sms-count-failed-value"}>{category.failedCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                        </Col>
                      </Row>

                      <br/>

                      <p className={"sms-count-description"}>{category.description}</p>
                      <button className={"sms-read-btn"}
                              onClick={() => this.categoryfilterHandler(category, index)}>Read
                        Messages
                      </button>
                    </div>
                  </Col>
                }) :
                <div className={"align-center fully-width"}>
                  <Empty description={"Records not found"} className={"empty-icon"}/>
                </div>
            }
          </Row>
          <p className={"hidden-field"}/>
          <Row>

            <Col>
              <br/><br/>
              {
                this.state.data.length !== 0 ?
                  <div className={"corporate-sms-report-wrapper"}>
                    <Card className="card margin0">
                      <CardHeader>
                        {
                          this.state.category_name
                        }
                        <Download data={this.state.data} filename={"tags-sms-report.csv"} userType={"VIEW_SMS"}/>
                      </CardHeader>
                      <CardBody>
                        {/*<Download right={true} data={this.state.data} filename={"tags-sms-report.csv"}*/}
                        {/*userType={"VIEW_SMS"}/>*/}
                        <MDBDataTable
                          searching={true}
                          searchLabel={"Search SMS"}
                          responsive
                          responsiveSm
                          responsiveMd
                          responsiveLg
                          responsiveXl
                          // striped={true}
                          bordered
                          hover
                          data={data}/>

                      </CardBody>
                    </Card>
                  </div>
                  : null
              }
            </Col>
          </Row>
        </Spin>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  usr_obj: state.userReducer.user
});

export default connect(mapStateToProps, null)(App);
